import {useGetRank} from "../../services/ContentManager";
import makeStyles from '@mui/styles/makeStyles';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, {useState} from "react";
import {Avatar} from "@mui/material";
import NTMXGrid from "../../components/NTMXGrid";
import userImage from "../../images/top_bar-profilo-over.svg";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {SettingsTooltip} from "../../components/forms/CustomTooltip";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import {resources} from "../../services/ability";
import ConfirmIconButton from "../../components/buttons/ConfirmIconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AchievementAward from "../Achievements/AchievementAward";
import {TextItem} from "../../components/TextItem";
import {genderCode} from "../../constants/genderCode";
import useGetUsefulValues from "../../constants/rankingUsefulValues";
import useGetRankingFilter from "../../constants/rankingFilter";
import useGetSessionType from "../../constants/sessionType";
import InfoGrid from "../../components/InfoGrid";

const useStyles = makeStyles(theme => ({
    backButton: {
        color: theme.palette.primary.main,
    },
    backButtonIcon: {
        margin: theme.spacing(1)
    },
    title: {
        padding: theme.spacing(1),
        fontWeight: "bold",
        color: theme.palette.primary.main,
        fontSize: 35,
        textAlign: "center"
    },
    text: {
        paddingLeft: theme.spacing(1),
        fontWeight: "bold",
        color: theme.palette.text.primary
    },
    box: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        borderBottom: `${theme.palette.secondary.main} 1px solid`,
        color: theme.palette.primary.dark,
        fontWeight: "bold",
        flexGrow: 1,
    },
}));

export default function RankInfo({goBack, rankId, national, customField, generalRank}) {

    const {t} = useTranslation();
    let classes = useStyles();
    let {rank = {}, status} = useGetRank(rankId, !generalRank);
    // {rank = {}, status} = useGetGeneralRank(!generalRank); toDo:fare classifica globale
    const [showAwards, setShowAwards] = useState(null);
    const usefulValues = useGetUsefulValues(national);
    const rankingFilter = useGetRankingFilter(customField);
    const sessionType = useGetSessionType();

    console.log(rank);

    const defaultColumns = [
        {
            headerName: t('position'),
            field: 'position',
            width: 200
        },
        {
            headerName: t('image'),
            field: 'avatarUrl',
            width: 200,
            renderCell: (params) => <Avatar src={params.value || userImage} alt="userImage"/>
        },
        {
            headerName: t('username'),
            field: 'username',
            width: 200,
        },
        {
            headerName: t('points'),
            field: 'points',
            width: 200
        },
        {
            headerName: t('award'),
            field: "info",
            width: 210,
            renderCell: (params) => <>
                {
                    params.row.award &&
                    <IconButton onClick={() => setShowAwards(params.row.award)} size="large"> <EmojiEventsIcon/>
                    </IconButton>
                }
            </>
        }
    ];

    const infos = [
        {
            isDate: true,
            field: 'startDate',
            label: t('startDate'),
        }, {
            isDate: true,
            field: 'endDate',
            label: t('endDate'),
        }, {
            findValueOptions: usefulValues,
            field: 'value',
            label: t('value'),
        },
        {
            field: 'repeatNum',
            label: t('repetitions'),
        },
        {
            findValueOptions: rankingFilter,
            field: 'filter',
            label: t('filter'),
        },
        rank.filter !== null && rank.filter === 0 && {
            findValueOptions: sessionType,
            field: 'filterValue',
            label: t('valueFilter'),
        },
        rank.filter !== null && rank.filter === 1 && {
            field: 'filterValue',
            label: t('valueFilter'),
        },
        rank.filter !== null && rank.filter === 2 && {
            findValueOptions: Object.values(genderCode).map(c => ({...c, name: t(c.value)})),
            field: 'filterValue',
            label: t('gender'),
        }
    ]

    if (showAwards) return <AchievementAward goBack={() => setShowAwards(null)} overrideAwards={[showAwards]}/>

    return (
        <Grid container justifyContent="space-between">
            {goBack && <Grid container justifyContent="space-between">
                <Button onClick={goBack} className={classes.backButton}>
                    <ArrowBackIcon className={classes.backButtonIcon}/>
                    {t('goBack')}
                </Button>
            </Grid>}
            {rank.startDate &&
                <>
                    <Grid xs={12}>
                        <div className={classes.title}>{rank.title}</div>
                    </Grid>
                    <Grid item xs={12}>
                        <InfoGrid infos={infos} data={rank}/>
                    </Grid>
                </>
            }

            <NTMXGrid
                key={"ranking-info-table"}
                columns={defaultColumns}
                loading={status === "loading"}
                rows={rank.rankingPositions || []}
                getRowId={(row) => rank && row.position}
            />
        </Grid>
    );
}
